const columns = [
  {
    label: 'Item',
    field: 'equipmentType'
  },
  {
    label: 'Hours',
    field: 'hours'
  },
  {
    label: 'Rate',
    field: 'rate'
  },
  {
    label: 'Amount',
    field: 'amount'
  },
]

export default function generateInvoicePdf(prepObj, doc, lastPage) {
  const {
    rows,
    total,
    timesheetId,
    invoiceNumber,
    invoiceDate,
    dueDate,
    vendor,
    address,
    city,
    state,
    zip,
    phone,
    fax
  } = prepObj

  function addHead(doc) {
    doc.setFontSize(9)
    doc.text('From', 1, 5)
    doc.text('Invoice', 205, 5, { align: 'right' })
    doc.text(vendor || '', 1, 10)
    doc.text(`Invoice #: ${invoiceNumber}`, 205, 10, { align: 'right' })
    doc.text(address || '', 1, 15)
    doc.text(`Invoice Date: ${invoiceDate}`, 205, 15, { align: 'right' })
    doc.text(`${city}, ${state} ${zip}`, 1, 20)
    doc.text(`Due Date: ${dueDate}`, 205, 20, { align: 'right' })
    doc.text(`${phone ? `Phone: ${phone}` : ''}`, 1, 25)
    doc.text(`Time Sheet ID: ${timesheetId}`, 205, 25, { align: 'right' })
    doc.text(`${fax ? `Fax: ${fax}` : ''}`, 1, 30)
    doc.text(' ', 1, 35)
    doc.text('To', 1, 40)
    doc.text('Martz Bros', 1, 45)
  }

  const pdfFormat = {
    head: [columns.map(({ label }) => label)],
    body: rows.map(d => columns.map(({ field }) => d[field])),
    foot: [[null, null, 'Total', total]],
    showFoot: 'lastPage',
    styles: {
      lineWidth: .1,
    },
    theme: 'plain',
    margin: [46, 0, 0, 0],
    columnStyles: {
      1: { halign: 'right' },
      2: { halign: 'right' },
      3: { halign: 'right' },
    },
    didParseCell: (data) => {
      data.table.foot.forEach((footRow) => {
        for (const key of Object.keys(footRow.cells)) {
          footRow.cells[key].styles.halign = 'right'
        }
      })
    },
  }

  addHead(doc)
  doc.autoTable(pdfFormat)
  
  if(!lastPage) {
    doc.addPage();
  }
}